export function Logo({ compact = false, size = 36, className = "", tone = "brand" }) {
  const box = size;
  const booksClass = tone === "mono" ? "text-rig-dim" : "text-rig-accent";
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <img
        src="/logo-mark.png"
        alt="RigBooks"
        draggable={false}
        className="rounded-xl object-cover shadow-[0_0_22px_rgba(0,230,118,0.35)]"
        style={{ width: box, height: box }}
      />
      {!compact && (
        <span
          className="font-display font-bold tracking-[0.14em] text-white leading-none"
          style={{ fontSize: Math.round(size * 0.66), textShadow: "0 1px 14px rgba(0,0,0,0.45)" }}
        >
          RIG<span className={booksClass}>BOOKS</span>
        </span>
      )}
    </div>
  );
}
